import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import {
  DateTime,
} from 'luxon';

import {
  coreSelectors,
  WorkoutEvent,
} from '@gymcloud/core';

import {
  Avatar,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import {
  data,
} from 'web-utils';

import * as S from './styled';

const getHeightString = (value: number, from: string, to: string) => {
  if (from === 'imperial' && to === 'imperial') {
    return data.inchesToFeetInches(value);
  }

  return data.heightConvert(value, from, to);
};

const yearsAgo = (str: string) => Math.floor(
  Math.abs(
    DateTime.fromFormat(str, 'yyyy-mm-dd').diffNow('years').years,
  ),
);

const mapState = state => ({
  settings: coreSelectors.getProfile('user_settings')(state),
});

type Props = {
  event: WorkoutEvent,
}

export default ({ event }: Props) => {
  const { settings } = useSelector(mapState, shallowEqual);

  return (
    <S.Header>
      <Flex align="center">
        <Avatar
          src={event.avatar?.thumb?.url}
          width="50px"
          height="50px"
          borderWidth={3}
          placeholderSize={25}
        />
        <h3
          style={{
            color: 'white',
            fontSize: '2rem',
            margin: 0,
            marginLeft: 10,
          }}
        >
          {event.person_name}
        </h3>
      </Flex>
      <S.UserStats>
        <S.Stat>
          <S.StatTitle>
            {`Height (${settings.units_system === 'imperial' ? 'ft\' in' : 'cm'})`}
          </S.StatTitle>
          <S.StatValue>
            {event.height
              ? getHeightString(event.height, event.units, settings.units_system)
              : '-'}
          </S.StatValue>
        </S.Stat>
        <S.Stat>
          <S.StatTitle>
            {`Weight (${settings.units_system === 'imperial' ? 'lbs' : 'kg'})`}
          </S.StatTitle>
          <S.StatValue>
            {event.weight
              ? Math.round(data.weightConvert(event.weight, event.units, settings.units_system))
              : '-'}
          </S.StatValue>
        </S.Stat>
        <S.Stat>
          <S.StatTitle>
            Bodyfat
          </S.StatTitle>
          <S.StatValue>
            {event.bodyfat || '-'}
          </S.StatValue>
        </S.Stat>
        <S.Stat>
          <S.StatTitle>
            Age
          </S.StatTitle>
          <S.StatValue>
            {event.birthday
              ? yearsAgo(event.birthday)
              : '-'}
          </S.StatValue>
        </S.Stat>
        <S.Stat>
          <S.StatTitle>
            Gender
          </S.StatTitle>
          <S.StatValue>
            {event.gender || '-'}
          </S.StatValue>
        </S.Stat>
      </S.UserStats>
    </S.Header>
  );
};
